import { onMounted, ref, onBeforeUnmount } from 'vue';

/**
 * This function returns a ref which must be attached to the container with links.
 */
export function useOpenLinksInNewTab() {
  const root = ref<HTMLElement|null>(null);

  function handleClick(e: MouseEvent) {
    const link = (e.target as HTMLElement).closest('a');
    if (!link || !root.value!.contains(link)) {
      return;
    }

    e.preventDefault();
    window.open(link.href, '_blank', 'noopener,noreferrer');
  }

  onMounted(() => {
    root.value!.addEventListener('click', handleClick);
  });

  onBeforeUnmount(() => {
    root.value!.removeEventListener('click', handleClick);
  });

  return root;
}
